// extracted by mini-css-extract-plugin
module.exports = {"root":"LatestNews_root__5C3QM","text":"LatestNews_text__HDsWI","heading":"LatestNews_heading__dpC0U","list":"LatestNews_list__Axeae","mobile_link":"LatestNews_mobile_link__ynHNF"};